/*!

=========================================================
* Material Dashboard React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import Assignment from '@material-ui/icons/Assignment';
import FlashOn from '@material-ui/icons/FlashOn';
import AccountTree from '@material-ui/icons/AccountTree';
import UsbIcon from '@material-ui/icons/Usb';
import Apps from '@material-ui/icons/Apps';
import Build from '@material-ui/icons/Build';
import CreateIcon from '@material-ui/icons/Create';
import Settings from '@material-ui/icons/Settings';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import BarChart from '@material-ui/icons/BarChart';
import DashboardIcon from '@material-ui/icons/Dashboard';

// core components/views for Admin layout
import TasksPage from './views/Tasks/Tasks.js';
import UserProfile from './views/UserProfile/UserProfile.js';
import TableList from './views/TableList/TableList.js';
import Typography from './views/Typography/Typography.js';
import EnginesPage from './views/Engines/EnginesPage.js';
import NotificationsPage from './views/Notifications/Notifications.js';

const dashboardRoutes = [
  {
    path: '/tasks',
    name: 'Tasks',
    project: true,
    icon: Assignment,
    component: TasksPage,
    layout: '/admin',
    resource: 'tasks',
  },
  {
    path: '/executions',
    name: 'Executions',
    project: true,
    icon: FlashOn,
    component: UserProfile,
    layout: '/admin',
    resource: 'executions',
  },
  {
    path: '/sequences',
    name: 'Sequences',
    project: true,
    icon: AccountTree,
    component: TableList,
    layout: '/admin',
    resource: 'sequences',
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    project: true,
    icon: BarChart,
    component: null,
    layout: '/admin',
    resource: 'dashboard',
  },
  {
    path: '/connections',
    name: 'Connections',
    project: true,
    icon: UsbIcon,
    component: Typography,
    layout: '/admin',
    adminOnly: true,
    resource: 'connections',
  },
  {
    path: '/engines',
    name: 'Apps',
    icon: Apps,
    component: EnginesPage,
    layout: '/admin',
    adminOnly: true,
    resource: 'engines',
  },
  {
    path: '/sharedconfig',
    name: 'Shared Config',
    project: true,
    icon: Build,
    component: NotificationsPage,
    layout: '/admin',
    permission: 'sharedConfigs',
    resource: 'sharedconfig',
  },
  {
    path: '/sharedfield',
    name: 'Shared Fields',
    project: true,
    icon: CreateIcon,
    component: NotificationsPage,
    layout: '/admin',
    permission: 'sharedFields',
    resource: 'sharedfield',
  },
  {
    path: '/admin/dashboard',
    name: 'Admin Dashboard',
    icon: DashboardIcon,
    component: null,
    layout: '/admin',
    globalAdminOnly: true,
    resource: 'admin-dashboard',
  },
  {
    path: '/admin/permissions',
    name: 'Users & Projects',
    icon: AccountCircleIcon,
    component: NotificationsPage,
    layout: '/admin',
    globalAdminOnly: true,
    resource: 'permissions',
  },
  {
    path: '/admin/login-config',
    name: 'Login Config',
    icon: Settings,
    component: null,
    layout: '/admin',
    globalAdminOnly: true,
    resource: 'login-config',
  },
];

export default dashboardRoutes;
